import { Box, Paper, Stack, Typography, useTheme } from '@mui/material';
import { Image } from '../../components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { memoizedOrganizationSelector } from './selectors'; // Correct path to selectors.js

export const Home = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  // Use the memoized selector to prevent unnecessary re-renders
  const organizations = useSelector(memoizedOrganizationSelector);

  const user = JSON.parse(localStorage.getItem('user'));
  const isSuperAdmin = user ? user.superadmin : false;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Stack direction="row" spacing={2} flexWrap="wrap">
        {organizations.map(({ id, label, img, to }) => (
          <Paper
            key={id}
            sx={{
              p: 3,
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background-color 0.3s ease',
              '&:hover': {
                backgroundColor: 'lightblue'
              }
            }}
            onClick={() => navigate(to)}
          >
            <Image
              src={img.default}
              alt={label}
              sx={{
                borderRadius: '100%',
                overflow: 'hidden',
                width: '10rem',
                aspectRatio: '1/1',
                boxShadow: theme.shadows[10]
              }}
            />
            <Typography sx={{ mt: 2 }} textAlign="center" variant="h5" fontWeight="bold">
              {label}
            </Typography>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
};
